const nominationApprovalStatus = [
    { label: 'Approve', value: '1' },
    { label: 'Reject', value: '2' }
];

export default nominationApprovalStatus;
